/* =========================================================
   New Announcement Bar (V1) — Ergomotion
   Safe, minimal JS
   - No DOM mutation
   - No reloads
   - No conflicts with theme
========================================================= */

(function () {
  const bar = document.querySelector('[data-new-announcement-bar]');
  if (!bar) return;

  // Reserved for future enhancements:
  // - close button
  // - session-based dismiss
  // - countdown timer
  // Currently intentionally empty to avoid conflicts
})();
